import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { FUNCTION_URLS } from "../lib/config";
import { queryKeys } from "../lib/queryKeys";
import type {
  ContactResearchRequest,
  ContactResearchResult,
  PersonalizationRequest,
  PersonalizationResult,
  RescoreRequest,
} from "../lib/types";

export function useContactResearch() {
  const qc = useQueryClient();
  return useMutation<ContactResearchResult, Error, ContactResearchRequest>({
    mutationFn: (body) =>
      callFunction<ContactResearchResult, ContactResearchRequest>(
        FUNCTION_URLS.contactResearch,
        body,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.contacts.all });
    },
  });
}

export function useRescore() {
  const qc = useQueryClient();
  return useMutation<ContactResearchResult, Error, RescoreRequest>({
    mutationFn: (body) =>
      callFunction<ContactResearchResult, RescoreRequest>(
        FUNCTION_URLS.rescore,
        body,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.contacts.all });
    },
  });
}

export function usePersonalization() {
  return useMutation<PersonalizationResult, Error, PersonalizationRequest>({
    mutationFn: (body) =>
      callFunction<PersonalizationResult, PersonalizationRequest>(
        FUNCTION_URLS.personalization,
        body,
      ),
  });
}
